exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".number[data-v-87eb36a4] {\n  background-color: #0374d7;\n  border-radius: 100px;\n  margin: 6px 5px 12px;\n  color: white;\n  width: 90px;\n  height: 90px;\n  text-align: center;\n}\n.percentage[data-v-87eb36a4] {\n  font-size: 1.3rem;\n  color: #0374d7;\n}\n.percentage.inverse[data-v-87eb36a4] {\n  color: white;\n}\n", ""]);

// exports
